import React, { useState } from "react";
import BookCover from "../Images/3D_Book_Cover_Financial_Compass.png";

const AMAZON_BOOK_ID = "B0D7QW8SPX";

function LandingPage() {
  const [imgError, setImgError] = useState(false);

const handleAmazonClick = () => {
  if (typeof window.fbq === "function") {
    window.fbq("track", "InitiateCheckout", {
      content_name: "The Financial Compass",
      content_ids: [AMAZON_BOOK_ID],
      content_type: "product",
      content_category: "Book",
      num_items: 1,
      button_location: "landing_page",
      destination: "amazon",
    });
  }
};

  return (
    <div className="min-h-screen bg-white px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="text-center">
          <p className="text-3xl font-semibold text-emerald-900 sm:text-4xl lg:text-5xl">
            “I did everything ‘right’ in school, yet I still feel lost with real-life money decisions.”
          </p>
        </div>

        <div className="mx-auto mt-8 sm:mt-16 grid max-w-6xl items-center gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:gap-20">
          <div className="rounded-3xl border border-emerald-200 bg-gray-50 p-6 shadow-xl shadow-emerald-100/60 sm:p-10">
            <div className="flex justify-center">
              <img
                src={BookCover}
                alt="The Financial Compass book cover"
                className="h-auto w-full max-w-xs sm:max-w-sm rounded-3xl object-contain"
              />
            </div>
          </div>

          <div className="space-y-8">
            <div>
              <h1 className="text-4xl font-bold tracking-tight text-emerald-900 sm:text-5xl">
                Finally, the financial education school never gave you.
              </h1>
              <div className="mt-5 flex flex-wrap items-center justify-center gap-3 text-2xl font-semibold text-slate-900">
                <div className="flex items-center gap-1 text-amber-500">
                  <span>★</span>
                  <span>★</span>
                  <span>★</span>
                  <span>★</span>
                  <span>★</span>
                </div>
                <span className="text-lg text-slate-700">4.9/5 Amazon Rating</span>
              </div>
            </div>

            <div className="space-y-4 text-base leading-8 text-slate-700 sm:text-lg">
              <p>
                Questions about housing, cars, insurance, debt, and investing suddenly carry real consequences, yet few people have ever been shown how these decisions actually work.
              </p>
              <p>
                This isn't a book about complex equations or boring spreadsheets. Instead, it breaks down the financial decisions you'll face in real life and explains them in a clear, practical way that is easy to understand and apply.
              </p>
            </div>

            <div className="space-y-4 text-slate-900 h-full flex flex-col justify-center items-start w-fit mx-auto">
              <div className="flex items-start gap-3">
                <span className="mt-1 inline-flex h-8 w-8 items-center justify-center rounded-full bg-emerald-900 text-white">✓</span>
                <p className="font-semibold text-lg mt-1">Stop feeling lost.</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="mt-1 inline-flex h-8 w-8 items-center justify-center rounded-full bg-emerald-900 text-white">✓</span>
                <p className="font-semibold text-lg mt-1">Skip years of costly trial and error.</p>
              </div>
            </div>

            <div className="rounded-3xl bg-amber-500 p-8 text-center shadow-2xl shadow-amber-300/40">
              <p className="text-xl font-semibold text-slate-900">Start making confident financial decisions today.</p>
              <a
                href="https://www.amazon.com/Financial-Compass-Navigate-Money-Confidence-ebook/dp/B0D7QW8SPX/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleAmazonClick}
                className="mt-8 inline-flex items-center justify-center rounded-3xl bg-black px-8 pt-4 pb-3 text-xl font-semibold text-white shadow-lg shadow-black/20 transition hover:bg-slate-900"
              >
                <>
                  <span className="mr-3" style={{transform: "translateY(-5px)"}}>Buy now on</span>
                  {!imgError ? (
                    <span style={{ display: "inline-block", height: "30px", overflow: "hidden", }}>
                      <img
                        src="https://pngpix.com/images/hd/amazon-logo-black-background-xb9pdemosnjfz9ej.jpg"
                        alt="Amazon"
                        style={{ maxHeight: "30px", display: "block", transform: "translateY(5px)" }}
                        onError={() => setImgError(true)}
                      />
                    </span>
                  ) : (
                    <span>Amazon</span>
                  )}
                </>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
